import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  instagramSec: {
    padding: "80px 0",
    background: COLORS.white,
    marginBottom: 0,
    "@media (max-width: 600px)": {
      padding: "50px 0 40px",
    },
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: 60,
    "@media (max-width: 600px)": {
      marginBottom: 20,
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: 16,
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: "50%",
      transform: "translateX(-50%)",
      width: 60,
      height: 4,
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
      borderRadius: 2,
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 12,
    },
  },
  subheading: {
    fontSize: "1.1rem",
    color: COLORS.textSecondary,
    maxWidth: 600,
    margin: "0 auto 30px !important",
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  instagramLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: `linear-gradient(135deg, #E4405F 0%, #C13584 100%)`,
    color: COLORS.white,
    padding: "12px 24px",
    borderRadius: 25,
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "1rem",
    fontFamily: "'Poppins', sans-serif",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(196, 53, 132, 0.3)",
      textDecoration: "none",
      color: COLORS.white,
    },
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  reelsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: 16,
    maxWidth: 1200,
    margin: "0 auto",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
      gap: 12,
    },
    "@media (max-width: 480px)": {
      gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
      gap: 10,
    },
  },
  reelCard: {
    background: COLORS.white,
    borderRadius: 12,
    overflow: "hidden",
    cursor: "pointer",
    position: "relative",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    aspectRatio: "9/16", // Instagram reel aspect ratio
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    },
    "&:hover $reelThumbnail video": {
      transform: "scale(1.05)",
    },
    "&:hover $hoverOverlay": {
      opacity: 1,
    },
  },
  reelThumbnail: {
    position: "relative",
    height: "100%",
    overflow: "hidden",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.3s ease",
    },
    "& video": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.3s ease",
    },
  },
  hoverOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.3s ease",
    zIndex: 2,
  },
  playIcon: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: COLORS.textPrimary,
    transition: "all 0.3s ease",
    transform: "scale(0.8)",
    "&:hover": {
      transform: "scale(1)",
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "& svg": {
      marginLeft: 4,
    },
  },
  reelDuration: {
    background: "rgba(0, 0, 0, 0.7)",
    color: COLORS.white,
    padding: "4px 8px",
    borderRadius: 12,
    fontSize: "0.8rem",
    fontWeight: 500,
    fontFamily: "'Poppins', sans-serif",
  },
  reelContent: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(transparent, rgba(0, 0, 0, 0.8))",
    padding: "20px 12px 12px",
    zIndex: 2,
  },
  reelTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: COLORS.white,
    margin: 0,
    marginBottom: '4px !important',
    fontFamily: "'Poppins', sans-serif",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
  },
  reelDescription: {
    fontSize: "0.8rem",
    color: COLORS.lightGrey,
    lineHeight: 1.4,
    marginBottom: '8px !important',
    fontFamily: "'Poppins', sans-serif",
  },
  reelStats: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  reelLikes: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    color: COLORS.lightGrey,
    fontSize: "0.85rem",
    fontFamily: "'Poppins', sans-serif",
    "& svg": {
      color: "#E4405F",
    },
  },
}));
